import { render } from "./PsychicAvailabilityComponent.vue?vue&type=template&id=2e05ebfc&scoped=true"
import script from "./PsychicAvailabilityComponent.vue?vue&type=script&lang=js"
export * from "./PsychicAvailabilityComponent.vue?vue&type=script&lang=js"

import "./PsychicAvailabilityComponent.vue?vue&type=style&index=0&id=2e05ebfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e05ebfc"]])

export default __exports__